const $ = jQuery.noConflict();

class ImageLinksSlider {
    constructor() {
        this.block = $('.block-fw-image-links');
        this.link = this.block.find('.block-fw-image-links__link');
        this.slider = this.block.find('.block-fw-image-links__wrapper .row');
        this.breakpoint = 767;
    }

    init() {
        this.toggleContent();
        this.initSlider();
    }

    toggleContent() {
        this.link.hover(function showContent() {
            $(this).find('.block-fw-image-links__link-hidden').stop().slideDown(200);
        }, function hideContent() {
            $(this).find('.block-fw-image-links__link-hidden').stop().slideUp(200);
        });
    }

    initSlider() {
        this.slider.slick({
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
            mobileFirst: true,
            responsive: [{
                breakpoint: this.breakpoint,
                settings: "unslick"
            }]
        });
    }

    resized() {
        if (window.matchMedia(`(max-width: ${this.breakpoint}px)`).matches && !this.slider.hasClass('slick-initialized')) {
            this.initSlider();
        }
    }
}

export default new ImageLinksSlider;
